<div class="col-sm-2 documents-status-filter">
    <div class="parcels-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="parcels-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="publicCheckbox" #publicCheckbox (change)="changeFilter()">
                <label for="publicCheckbox"><svg-checked></svg-checked></label>
                <span>Public</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="notPublicCheckbox" #notPublicCheckbox (change)="changeFilter()">
                <label for="notPublicCheckbox"><svg-checked></svg-checked></label>
                <span>Not Public</span>
            </label>
        </div>

        <hr>

        <div class="document-owner-types-wrapper">
            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="all" #all (change)="changeFilter()">
                    <label for="all"><svg-checked></svg-checked></label>
                    <span>All</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="resident" #resident (change)="changeFilter()">
                    <label for="resident"><svg-checked></svg-checked></label>
                    <span>Resident</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="ownerOnSite" #ownerOnSite (change)="changeFilter()">
                    <label for="ownerOnSite"><svg-checked></svg-checked></label>
                    <span>Owner On-Site</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="tenant" #tenant (change)="changeFilter()">
                    <label for="tenant"><svg-checked></svg-checked></label>
                    <span>Tenant</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="ownerAll" #ownerAll (change)="changeFilter()">
                    <label for="ownerAll"><svg-checked></svg-checked></label>
                    <span>Owner All</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="ownerOffSite" #ownerOffSite (change)="changeFilter()">
                    <label for="ownerOffSite"><svg-checked></svg-checked></label>
                    <span>Owner Off-Site</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="residentOwner" #residentOwner (change)="changeFilter()">
                    <label for="residentOwner"><svg-checked></svg-checked></label>
                    <span>Resident Owner</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="residentOnlyNotOnDeed" #residentOnlyNotOnDeed (change)="changeFilter()">
                    <label for="residentOnlyNotOnDeed"><svg-checked></svg-checked></label>
                    <span>Resident Only Not On Deed</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="ownerFamily" #ownerFamily (change)="changeFilter()">
                    <label for="ownerFamily"><svg-checked></svg-checked></label>
                    <span>Owner Family</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="guest" #guest (change)="changeFilter()">
                    <label for="guest"><svg-checked></svg-checked></label>
                    <span>Guest</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="offsiteResident" #offsiteResident (change)="changeFilter()">
                    <label for="offsiteResident"><svg-checked></svg-checked></label>
                    <span>Offsite Resident</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="occupant" #occupant (change)="changeFilter()">
                    <label for="occupant"><svg-checked></svg-checked></label>
                    <span>Occupant</span>
                </label>
            </div>

            <div class="m-b-xs filter-checkbox">
                <label class="img-checkbox">
                    <input type="checkbox" id="notSet" #notSet (change)="changeFilter()">
                    <label for="notSet"><svg-checked></svg-checked></label>
                    <span>Not Set</span>
                </label>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/documents-status-filter/documents-status-filter.component.html